import { motion } from 'framer-motion';

export function CyberBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-50 overflow-hidden bg-background"
    >
      {/* Grid */}
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage: `linear-gradient(to right, hsl(var(--foreground) / 0.4) 1px, transparent 1px),
                            linear-gradient(to bottom, hsl(var(--foreground) / 0.4) 1px, transparent 1px)`,
          backgroundSize: '40px 40px',
          maskImage:
            'radial-gradient(ellipse at top, rgba(0,0,0,0.9) 0%, transparent 70%)',
          WebkitMaskImage:
            'radial-gradient(ellipse at top, rgba(0,0,0,0.9) 0%, transparent 70%)',
        }}
      />

      {/* Radial glows */}
      <motion.div
        animate={{ scale: [1, 1.2, 1], opacity: [0.25, 0.45, 0.25] }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute -left-[10%] -top-[20%] h-[60%] w-[60%] rounded-full bg-primary/25 blur-[120px]"
      />
      <motion.div
        animate={{ scale: [1.2, 1, 1.2], opacity: [0.18, 0.35, 0.18] }}
        transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute -bottom-[20%] -right-[10%] h-[60%] w-[60%] rounded-full bg-primary/15 blur-[120px]"
      />
      <motion.div
        animate={{ opacity: [0.1, 0.25, 0.1] }}
        transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute left-1/2 top-1/3 h-[40%] w-[40%] -translate-x-1/2 rounded-full bg-primary/10 blur-[100px]"
      />
    </div>
  );
}
